import App from './App.vue'
import store from './vuex/store'
import router from './router'
import {sync} from 'vuex-router-sync'

sync(store, router)

router.start(App, '#app')



// WEBPACK FOOTER //
// ./src/main.js